import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { AuthorityDataService } from "../../core/authorities.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-authority",
    template: require('../shared/edit-view.html')
})
export class EditAuthority extends EditBase<Nema.Crew.Model.Authority> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('authority') entity: Nema.Crew.Model.Authority,
        @Inject('authorityDataService') authorityDataService: AuthorityDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, authorityDataService, $log, isNew);
    }

    public entityDisplayName = "Authority";

    public listStateName = "app.settings.authorities";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/authorities/authority.edit.component.ts